// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/check.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'check',
  version: 'outline',
  paths: [
    {
      d: 'm4.5 12.75 6 6 9-13.5',
    },
  ],
}
